var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 36.75C38 37.3467 37.7598 37.919 37.3322 38.341C36.9046 38.7629 36.3247 39 35.72 39H2.28C1.67531 39 1.09538 38.7629 0.667797 38.341C0.240214 37.919 0 37.3467 0 36.75C0 36.1533 0.240214 35.581 0.667797 35.159C1.09538 34.7371 1.67531 34.5 2.28 34.5H35.72C36.3247 34.5 36.9046 34.7371 37.3322 35.159C37.7598 35.581 38 36.1533 38 36.75ZM20.52 27.75V11.25C20.52 10.2554 20.9204 9.30161 21.633 8.59835C22.3456 7.89509 23.3122 7.5 24.32 7.5H31.16C32.1678 7.5 33.1344 7.89509 33.847 8.59835C34.5596 9.30161 34.96 10.2554 34.96 11.25V27.75C34.96 28.7446 34.5596 29.6984 33.847 30.4016C33.1344 31.1049 32.1678 31.5 31.16 31.5H24.32C23.3122 31.5 22.3456 31.1049 21.633 30.4016C20.9204 29.6984 20.52 28.7446 20.52 27.75ZM25.08 27H30.4V12H25.08V27ZM3.04 27.75V3.75C3.04 2.75544 3.44036 1.80161 4.15299 1.09835C4.86563 0.395088 5.83218 0 6.84 0H13.68C14.6878 0 15.6544 0.395088 16.367 1.09835C17.0796 1.80161 17.48 2.75544 17.48 3.75V27.75C17.48 28.7446 17.0796 29.6984 16.367 30.4016C15.6544 31.1049 14.6878 31.5 13.68 31.5H6.84C5.83218 31.5 4.86563 31.1049 4.15299 30.4016C3.44036 29.6984 3.04 28.7446 3.04 27.75ZM7.6 27H12.92V4.5H7.6V27Z",
    fill: "#FBF9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevenue);
export default __webpack_public_path__ + "static/media/icon-revenue.7926343a5b40c5a904739d0541971036.svg";
export { ForwardRef as ReactComponent };